<div class="text-center">
    <h2 class="not-found">We could not find the store <strong>{{storeFormattedAddress}}</strong></h2>
    <a href="#" mat-flat-button  (click)="goToHome()">Discover stores near you instead</a>
</div> 



